import React from 'react'

const Privacy = () => (
  <section className="ob-privacy js-privacy">
    <h2 className="zb-heading2 js-title">Privacy and Cookies</h2>
    <div className="zb-card ob-card">
      <h3 className="zb-heading3">Your privacy</h3>
      <div>
        <p>
          We promise to treat any personal information about you securely,
          fairly and lawfully. We are committed to protecting your privacy.
        </p>
      </div>
      <h3 className="zb-heading3">Cookies – what are they?</h3>
      <div>
        <p>
          A "cookie" is a small text file that's stored on your computer,
          smartphone, tablet, or other device when you visit a website or use an
          app.
        </p>
        <p>
          Some cookies are deleted when you close down your browser. These are
          known as <b>session cookies</b>. Others remain on your device until
          they expire or you delete them from your cache. These are known as{' '}
          <b>persistent cookies</b> and enable us to remember things about you
          as a returning visitor.
        </p>
        <p>This website uses session cookies only.</p>
      </div>
      <h3 className="zb-heading3">How to control and delete cookies. </h3>
      <div>
        <p>
          If you want to restrict or block the cookies we set, you can do this
          through your browser settings. The ‘help’ function within your browser
          should tell you how.
        </p>
        <p>
          To find out more about cookies, including how to see what cookies have
          been set and how to manage and delete them, visit{' '}
          <a
            href={'www.allaboutcookies.org'}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="More information about cookies, an external link that will open in a new tab"
          >
            www.allaboutcookies.org
          </a>
          . Alternatively, you can search the internet for other independent
          information on cookies.
        </p>
      </div>
      <h3 className="zb-heading3">Cookies – how we use them</h3>
      <div>
        <p>
          If you delete cookies relating to this website we will not remember
          things about you, including your cookie preferences, and you will be
          treated as a first-time visitor the next time you visit the site.
        </p>
        We use cookies (and other similar technologies) to:
        <ul>
          <li>Provide a secure online environment</li>
          <li>
            Give you a better online experience and track website performance
          </li>
        </ul>
        <p>
          Here we explain a bit more about each of these types and how you can
          control their use.
        </p>
      </div>
      <h3 className="zb-heading3">Essential Cookies</h3>
      <div>
        <p>
          Cookies that are essential for us to provide a product or service you
          have requested and to provide a secure online environment. Without
          cookies we are unable to provide some products or services that you
          might request. Other 'essential' cookies keep our website secure.
          Preventing these cookies may result in a poor user experience.
        </p>
        Essential cookies are used to:
        <ul>
          <li>maintain online security and protect against online fraud</li>
          <li>
            deliver interactive services, such as:
            <ul>
              <li>online banking </li>
              <li>product applications</li>
              <li>web chat </li>
              <li>call-backs</li>
            </ul>
          </li>
          <li>
            record your preference regarding our use of cookies on your device
          </li>
        </ul>
      </div>
      <h3 className="zb-heading3">
        Performance Cookies: Tracking website performance
      </h3>
      <div>
        <p>
          These cookies collect aggregated information and are not used to
          identify you.
        </p>
        <p>
          We use this type of cookie to understand and analyse how visitors use
          our online services and look for ways to improve them. For example, a
          cookie might tell us that lots of people give up on an enquiry process
          at a particular step – so we can try to make that step easier to
          complete.
        </p>
        The analytics cookies we use include:
        <ul>
          <li>
            <b>Google Analytics</b>, which uses cookies to help us analyse how
            our visitors use the site. Find out more about how these cookies are
            used on the Google privacy site.
          </li>
          <li>
            <b>IBM NetInsight</b>, to analyse how our visitors use our sites.
            NetInsight uses both session and persistent cookies.
          </li>
          <li>
            <b>Adobe Analytics</b> , to improve our websites and services. This
            service and the cookies it uses help us understand the popularity of
            our content and make better consumer experiences.
          </li>
        </ul>
      </div>
      <h3 className="zb-heading3">
        Functionality Cookies: Giving you a better online experience{' '}
      </h3>
      <div>
        <p>
          These cookies remember your preferences and tailor the website to
          provide enhanced features. Without these cookies, we cannot remember
          your choices or personalise your online experience.
        </p>
        We use this type of cookie to:
        <ul>
          <li>
            Make accessing your agreements faster by remembering you between
            visits on your personal devices
          </li>
          <li>
            Remembering relevant information as you browse from page to page to
            save you re-entering the same information repeatedly{' '}
          </li>
        </ul>
      </div>
      <h3 className="zb-heading3">Targeting Cookies</h3>
      <div>
        <p>
          These cookies are usually service-provider cookies from marketing
          partners used to deliver adverts relevant to you and your interests.
          These cookies can track your browsing history across websites. If you
          wish to prevent this type of cookie, you may do so through your
          device’s browser security settings.
        </p>
        The service-provider companies we partner with include:
        <ul>
          <li>Doubleclick</li>
          <li>Facebook</li>
          <li>Amazon</li>
          <li>OMG</li>
          <li>Taboola</li>
          <li>Google Search Adwords</li>
          <li>AOL</li>
          <li>Lovemoney</li>
        </ul>
      </div>
      <h3 className="zb-heading3">Cookies in emails</h3>
      <p>
        As well as the cookies we use on our website, we use cookies and similar
        technologies in emails. These help us to understand whether you’ve
        opened an email and how you’ve interacted with it. Cookies may also be
        set if you click on a link within the email.
      </p>
      <h4 className="zb-heading4">How to control and delete cookies</h4>
      <p>
        If you don't want to accept cookies in emails, you can set your browser
        to restrict or reject cookies, or you can close the email before
        downloading any images or clicking on any links.
      </p>
    </div>
  </section>
)

export default Privacy
